import React, { useEffect, useState, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { CButton, CModal, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import './content.scss'
import '../../../scss/style.scss'
import AssetType from './AssetType'
import ContentDetails from './ContentDetails'
import Setting from './setting'
import PricingAndPublish from './pricingAndPublish'
import { getContentCall } from '../../../Redux/Actions/contentAction'
import Upload from './upload'
import { AppContext } from 'src/views/context/app'
import AssetTypeIcon from '../../../assets/Content-Icons/PNGs/asset-type.png'
import UploadMediaIcon from '../../../assets/Content-Icons/PNGs/upload-media.png'
import DetailsIcon from '../../../assets/Content-Icons/PNGs/content-details.png'
import SettingsIcon from '../../../assets/Content-Icons/PNGs/advance-settings.png'
import PricingIcon from '../../../assets/Content-Icons/PNGs/pricing-publish.png'
import Playlist from './playlist'

const CreateContent = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [isEdit, setIsEdit] = useState(false)
  const [details, setDetails] = useState({})

  const [toggleState, setToggleState] = useState(1)
  const [cancelModal, setCancelModal] = useState(false)
  const [currentState, setCurrentState] = useState(1)
  const { setLoader } = useContext(AppContext)
  const content = useSelector((state) => state.contentReducer)

  useEffect(() => {
    if (location.state && location.state.id && location.state.isEdit) {
      setIsEdit(true)
      setLoader(true)
      getContent(location.state.id)
    }
  }, [location])

  const getContent = async (id) => {
    const res = await dispatch(getContentCall(id))

    if (res?.success) {
      let data = res.data
      delete data['account_id']
      delete data['created_date']
      delete data['created_by']
      dispatch({ type: 'SET_EDIT_VALUES', payload: data })
      setDetails(data)
      if (data?.asset_type && data?.video_type) {
        setToggleState(2)
      }
    }
    setLoader(false)
  }

  const toggleTab = (index) => {
    setToggleState(index)
  }

  const handleCancel = () => {
    dispatch({ type: 'EMPTY_CONTENT' })
    setCancelModal(false)
  }

  useEffect(() => {
    if (toggleState > currentState) {
      setCurrentState(toggleState)
    }
  }, [toggleState])

  let componentProps = {
    toggleValue: setToggleState,
    cancelModal: setCancelModal,
    isEdit: isEdit,
    details: details,
  }

  return (
    <>
      <nav className="content-details-navbar">
        <div
          className={`progress-bar 
            ${
              (toggleState > 1 && toggleState <= 2 && 'w-20p') ||
              (toggleState > 2 && toggleState <= 3 && 'w-42p') ||
              (toggleState > 3 && toggleState <= 4 && 'w-64p') ||
              (toggleState > 4 && 'w-88p')
            }
          `}
        ></div>
        <div className="cdetails" onClick={() => toggleTab(1)}>
          <img src={AssetTypeIcon} alt="" className="cdetails-nav-img" />
          <div className={`cdetails-marker ${toggleState > 1 ? 'cdetails-marker-done' : ``}`}></div>
          <p className="cdetails-text">Asset Type</p>
        </div>
        <div className="cdetails" onClick={() => (currentState >= 2 ? toggleTab(2) : null)}>
          <img
            src={UploadMediaIcon}
            alt=""
            className={`cdetails-nav-img ${toggleState >= 2 ? '' : 'cdetails-nav-img-unactive'}`}
          />
          {/* if toggle state is more than 2 show "done", if equal(active/current page) no classes, if less "unactive" */}
          <div
            className={`cdetails-marker ${
              toggleState >= 2
                ? toggleState > 2
                  ? 'cdetails-marker-done'
                  : ''
                : 'cdetails-marker-unactive'
            }`}
          ></div>
          <p className={`cdetails-text ${toggleState >= 2 ? '' : 'cdetails-text-unactive'}`}>
            Upload
          </p>
        </div>
        <div className="cdetails" onClick={() => (currentState >= 3 ? toggleTab(3) : null)}>
          <img
            src={DetailsIcon}
            alt=""
            className={`cdetails-nav-img ${toggleState >= 3 ? '' : 'cdetails-nav-img-unactive'}`}
          />
          <div
            className={`cdetails-marker ${
              toggleState >= 3
                ? toggleState > 3
                  ? 'cdetails-marker-done'
                  : ''
                : 'cdetails-marker-unactive'
            }`}
          ></div>
          <p className={`cdetails-text ${toggleState >= 3 ? '' : 'cdetails-text-unactive'}`}>
            Content Details
          </p>
        </div>
        <div className="cdetails" onClick={() => (currentState >= 4 ? toggleTab(4) : null)}>
          <img
            src={SettingsIcon}
            alt=""
            className={`cdetails-nav-img ${toggleState >= 4 ? '' : 'cdetails-nav-img-unactive'}`}
          />
          <div
            className={`cdetails-marker ${
              toggleState >= 4
                ? toggleState > 4
                  ? 'cdetails-marker-done'
                  : ''
                : 'cdetails-marker-unactive'
            }`}
          ></div>
          <p className={`cdetails-text ${toggleState >= 4 ? '' : 'cdetails-text-unactive'}`}>
            Settings
          </p>
        </div>
        <div className="cdetails" onClick={() => (currentState >= 5 ? toggleTab(5) : null)}>
          <img
            src={PricingIcon}
            alt=""
            className={`cdetails-nav-img ${toggleState >= 5 ? '' : 'cdetails-nav-img-unactive'}`}
          />
          <div
            className={`cdetails-marker ${
              toggleState >= 5
                ? toggleState > 5
                  ? 'cdetails-marker-done'
                  : ''
                : 'cdetails-marker-unactive'
            }`}
          ></div>
          <p className={`cdetails-text ${toggleState >= 5 ? '' : 'cdetails-text-unactive'}`}>
            Set Pricing & Publish
          </p>
        </div>
      </nav>

      <div className="content-tabs">
        <div className={toggleState === 1 ? 'content  active-content' : 'content'}>
          <AssetType {...componentProps} />
        </div>
        <div className={toggleState === 2 ? 'content  active-content' : 'content'}>
          {content.video_type === 'PLAYLIST' ? (
            <Playlist {...componentProps} />
          ) : (
            <Upload {...componentProps} />
          )}
        </div>
        <div className={toggleState === 3 ? 'content  active-content' : 'content'}>
          <ContentDetails {...componentProps} />
        </div>

        <div className={toggleState === 4 ? 'content  active-content' : 'content'}>
          <Setting {...componentProps} />
        </div>

        <div className={toggleState === 5 ? 'content  active-content' : 'content'}>
          <PricingAndPublish {...componentProps} />
        </div>
      </div>

      {/* ..............Cancel Modal.......... */}
      <CModal visible={cancelModal} alignment="center">
        <CModalHeader>
          <CModalTitle>Are you sure you want to Cancel ?</CModalTitle>
        </CModalHeader>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={() => setCancelModal(false)}>
            Cancel
          </CButton>
          <Link to="/content">
            <CButton className="text-white" color="info" onClick={handleCancel}>
              Yes
            </CButton>
          </Link>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default CreateContent
